import type { Directive } from 'vue'

/**
 * `v-page-in="key"`: the element plays its entrance (`animate-page-in`) when it first shows and each
 * time the key changes (a new screen), without being rebuilt: the screen keeps its instance and state.
 */
function play(el: HTMLElement): void {
  el.classList.remove('animate-page-in')
  // Read once, so the class removed and put back starts the animation again.
  void el.offsetWidth
  el.classList.add('animate-page-in')
}

export const vPageIn: Directive<HTMLElement, unknown> = {
  mounted: (el) => play(el),
  updated: (el, b) => { if (b.value !== b.oldValue) play(el) },
}
